import fetch from './fetch'

export default {
  transferRecord (payload) {
    let modelName = payload.modelName
    delete payload.modelName

    let request = fetch({
      url: `/transfer/` + modelName,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  getTransferOrganizations (payload) {
    let request = fetch({
      url: `/transfer/organizations`,
      method: 'post',
      data: payload
    })
    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/transfer.js